import React, { useContext, useEffect, useState } from "react";
import upload from "../../assets/images/Upload_icon.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { simpleGetCall, simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import Modal from "react-bootstrap/Modal";
import { AppContext } from "../../context/AppContext";

// import { HyperKycConfig } from 'hyperverge-web-sdk';
// import { hyperKycConfig } from 'hyperverge-web-sdk';
// import { HyperKYCModule } from 'hyperverge-web-sdk';
const AgeVerification = () => {
  const {
    LinkproductId,
    setpickID,
    setLinkVendingmachineid,
    setLinkproductId,
    setLinkslotno,
    LinkOrderId,
    setLinkOrderId,
    ageTokan,
    setAgeTokan,
    LinkVendingmachineid,
    Linkslotno,
    Linkdevicetoken,
  } = useContext(AppContext);

  const [key4, orderIdLink] = LinkOrderId?.split("=");
  const navigate = useNavigate();
  const handleClose = () => {
    setModalShow(false);
  };
  const location = useLocation();
  console.log("location", location);
  let token = location.pathname?.split("/");

  useEffect(() => {
    //  debugger
    if (ageTokan) {
      localStorage.setItem("userid", JSON.stringify(ageTokan.userid));
    }
  }, [ageTokan]);

  useEffect(() => {
    //  debugger
    if (token[2]) {
      console.log("token", token);
      // const OrderLinkID = token[2]
      // localStorage.setItem('OrderLinkID', JSON.stringify(OrderLinkID));
      // setLinkOrderId(OrderLinkID)
      const productLinkID = token[2];
      localStorage.setItem("productLinkID", JSON.stringify(productLinkID));

      setLinkproductId(productLinkID);
      const vendingmachineidLinkID = token[3];
      localStorage.setItem(
        "vendingmachineidLinkID",
        JSON.stringify(vendingmachineidLinkID)
      );

      setLinkVendingmachineid(vendingmachineidLinkID);
      const slotnoLinkID = token[4];
      localStorage.setItem("slotnoLinkID", JSON.stringify(slotnoLinkID));

      setLinkslotno(slotnoLinkID);

      const OrderLinkID = token[5];
      localStorage.setItem("OrderLinkID", JSON.stringify(OrderLinkID));
      setLinkOrderId(OrderLinkID);
      // const devicetokenID = token[6]
      // localStorage.setItem('devicetokenID', JSON.stringify(devicetokenID));

      // setLinkdevicetoken(devicetokenID)
    }
  }, [token]);

  useEffect(() => {
    const items4 = JSON.parse(localStorage.getItem("OrderLinkID"));
    const [key4, value4] = items4?.split("=");

    if (items4) {
      setpickID(value4);
    }
  }, []);

  const handlelink = () => {
    setModalShow(false);

    window.location.href = `https://wellbeingfarms.page.link/?amv=1&apn=com.app.wellbeingfarms&link=http://www.wellbeing.com?${LinkOrderId}&${LinkproductId}&${LinkVendingmachineid}&${Linkslotno}`;
  };
  const handleShow = () => setModalShow(true);
  const [modalShow, setModalShow] = useState(false);

  console.log(ageTokan);
  useEffect(() => {
    handleShow();
  }, []);

  useEffect(() => {
    getAgeVerification();
  }, []);

  const getAgeVerification = () => {
    simpleGetCall(ApiConfig.AGE_VERIFICATION)
      .then((res) => {
        console.log(res);
        setAgeTokan(res);
      })
      .catch((error) => {
        console.log("catch error response,", error);
      });
  };

  const startdemo = (e) => {
    const accessToken = ageTokan.token;
    const workflowId = "USA_age_verification";
    const transactionId = ageTokan.userid;

    const hyperKycConfigNew = new window.HyperKycConfig(
      accessToken,
      workflowId,
      transactionId
    );

    const handler = (HyperKycResult) => {
      console.log("HyperKycResult", HyperKycResult);
      switch (HyperKycResult.status) {
        case "user_cancelled":
          // user cancelled

          userAgeVerifiction(e, "cancelled", false);

          navigate("/Failed");
          console.log("workflow cancelled");

          break;
        case "error":
          userAgeVerifiction(e, "cancelled", false);

          navigate("/Failed");
          console.log("workflow cancelled");

          break;
        case "auto_approved":
          userAgeVerifiction(e, "success", true);
          navigate("/Success");

          break;

        case "auto_declined":
          userAgeVerifiction(e, "cancelled", false);
          navigate("/ScanFaild");

          console.log("workflow cancelled");

          break;

        case "needs_review":
          console.log("workflow needs_review");

          userAgeVerifiction(e, "success", true);
          navigate("/Success");
          // workflow success

          console.log("workflow success");

          break;
      }
    };
    window.HyperKYCModule.launch(hyperKycConfigNew, handler);
  };
  //

  const userAgeVerifiction = (e, userStaus, ageverify) => {
    e.preventDefault();

    let body = JSON.stringify({
      userid: ageTokan.userid,
      status: userStaus,
      token: ageTokan.token,
      orderId: orderIdLink,
      isAgeVerify: ageverify,
    });
    simplePostCall(ApiConfig.AGE_VERIFICATION_POST, body)
      .then((res) => {
        // if(ageverify === true){
        //   navigate("/Success");
        // } else{
        //   navigate("/Failed");
        // }

        console.log(res);
      })

      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className="form_wrapper" id="defaultModalCus">
      <div className="form_contain">
        <div className="heading">Age Verification</div>
        <div className="form_heading">
          In order to purhes this product, we need to be 100% sure that you are
          21 years old.
        </div>
        <div className="form_body">
          <label htmlFor="fileupload">
            <input />
            <img
              src={upload}
              alt="Upload"
              onClick={(e) => {
                startdemo(e);
              }}
            />
          </label>
        </div>
        <div className="form_footer">
          <div>
            <Link
              type="button"
              onClick={(e) => {
                startdemo(e);
              }}

              // onClick={(e) => {
              //            userAgeVerifiction(e,"success", true);

              // }}
            >
              Upload
            </Link>
          </div>
        </div>
      </div>
      <Modal
        show={modalShow}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="Main_header"
      >
        <Modal.Body>
          <div className="delete-msg text-center">
            <label htmlFor="">Do you want to download our app?</label>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <div className="buttons-modal">
            <button onClick={handlelink} className="me-4 " type="submit">
              Yes
            </button>
            <button to="#" className="" onClick={handleClose}>
              No
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AgeVerification;
